import React from 'react';
import Select from 'react-select';
import get from 'lodash/get';

export const PRINT_BORDER_SETTING_KEY = 'printBorder';

// Default matches the current behaviour (field keeps its full border).
export const PRINT_BORDER_DEFAULT = 'borders';

export const PRINT_BORDER_OPTIONS = [
  { value: 'borders', label: 'Borders' },
  { value: 'none', label: 'No borders' },
  { value: 'bottom', label: 'Bottom line' },
];

const selectStyles = {
  menu: (provided) => ({
    ...provided,
    zIndex: 9,
  }),
};

// Controls how the field border is rendered on print / PDF export only.
// Has no effect while the form is being displayed or filled.
const PrintBorderSetting = ({ element, onChange }) => {
  const value = get(element, `options[${PRINT_BORDER_SETTING_KEY}]`) || PRINT_BORDER_DEFAULT;
  const activeOption = PRINT_BORDER_OPTIONS.find((option) => option.value === value) || PRINT_BORDER_OPTIONS[0];

  const handleChange = (option) => {
    if (!element?.id || !onChange) return;
    onChange(option.value, PRINT_BORDER_SETTING_KEY, element.id);
  };

  return (
    <div className="property-item">
      <h3 className="form-builder-aside-property-sub-title">Print Border</h3>
      <div className="form-control-item">
        <Select
          className="form-control-select"
          value={activeOption}
          options={PRINT_BORDER_OPTIONS}
          styles={selectStyles}
          onChange={handleChange}
        />
      </div>
    </div>
  );
};

export default PrintBorderSetting;
